export const formatCustomerIndexLabel = (
  customerNo: number | undefined,
  customerIndex: string | undefined
) => {
  if (customerNo === undefined) {
    return customerIndex ?? "";
  }
  return customerIndex
    ? `${customerIndex} (${customerNo})`
    : String(customerNo);
};
